<template>
  <div class="authWrapper new-login-wrapper forget-email-wrapper">
    <div class="container">
      <div class="row login-white-wrap whiteBG-wrap login-margin">
        <div class="col-lg-7 col-md-7 no-padding">
          <div class="login-left-wrap">
            <div class="email-login-form">
              <div class="left-login">
                <div class="rep-icon-login">
                  <img src="../../assets/images/member-login.svg" alt="Member login icon" />
                </div>
                <div>
                  <router-link to="/" class="login-highlight back-btn-pwd">Back</router-link>
                </div>
              </div>
              <h4 class="login-title mb-1">Recover Your Login Email</h4>
              <p class="sub-head mb-2">Enter the details below to securely retrieve your registered email address.</p>

              <div class="auth-form pt-1 pb-3">
                <form @submit.stop.prevent="verifyMember">
                  <!-- Last Name -->
                  <b-form-group label="Last Name" label-for="lastname" class="form-group mb-3">
                    <b-form-input id="lastname" type="text" v-model="lastname" placeholder="Enter your last name"
                      :class="{ 'is-invalid': formErrors.lastname }" aria-describedby="lastname-help lastname-error"
                      autocomplete="family-name" aria-required="true" />
                    <small id="lastname-help" class="form-text text-muted" v-if="!formErrors.lastname">
                      Enter the last name associated with your account
                    </small>
                    <div id="lastname-error" class="valid-error" v-if="formErrors.lastname" role="alert"
                      aria-live="polite">
                      {{ formErrors.lastname }}
                    </div>
                  </b-form-group>

                  <!-- SSN -->
                  <b-form-group label="Last 4 Digits of SSN" label-for="cssn" class="form-group mb-3">
                    <b-form-input id="cssn" type="text" maxlength="4" v-model="cssn4" placeholder="0123"
                      :class="{ 'is-invalid': formErrors.cssn }" aria-describedby="cssn-help cssn-error"
                      autocomplete="off" inputmode="numeric" pattern="[0-9]{4}" aria-required="true" @input="onCssnInput" @keypress="onCssnKeypress" />
                    <small id="cssn-help" class="form-text text-muted" v-if="!formErrors.cssn">
                      Enter the last 4 digits of your Social Security Number
                    </small>
                    <div id="cssn-error" class="valid-error" v-if="formErrors.cssn" role="alert" aria-live="polite">
                      {{ formErrors.cssn }}
                    </div>
                  </b-form-group>

                  <!-- DOB -->
                  <b-form-group label="Date of Birth" label-for="dob" class="form-group mb-3">
                    <div class="date_of_birth" role="group" aria-label="Date of Birth" aria-required="true">
                      <b-form-select v-model="selected_month" :options="months"
                        :class="{ 'is-invalid': formErrors.dob }" class="m-0" aria-label="Month"
                        aria-describedby="dob-help dob-error" />
                      <b-form-select v-model="selected_day" :options="days" :class="{ 'is-invalid': formErrors.dob }"
                        class="m-0" aria-label="Day" />
                      <b-form-select v-model="selected_year" :options="years" :class="{ 'is-invalid': formErrors.dob }"
                        class="m-0" aria-label="Year" />
                    </div>
                    <small id="dob-help" class="form-text text-muted" v-if="!formErrors.dob">
                      Select your date of birth (Month, Day, Year)
                    </small>
                    <div id="dob-error" class="valid-error" v-if="formErrors.dob" role="alert" aria-live="polite">
                      {{ formErrors.dob }}
                    </div>
                  </b-form-group>

                  <!-- API Error -->
                  <div class="valid-error" v-if="formErrors.error" role="alert" aria-live="assertive">
                    {{ formErrors.error }}
                  </div>

                  <!-- Submit -->
                  <button type="submit" class="submit-btn mt-3 next-btn ml-0" :disabled="verifyLoader"
                    :aria-busy="verifyLoader" aria-label="Continue to recover email">
                    <b-spinner v-if="verifyLoader" small class="mr-2"></b-spinner>
                    <span v-if="!verifyLoader">Continue</span>
                    <span v-else>Processing...</span>
                  </button>

                  <!-- Footer -->
                  <div class="login-signup-btn-wrap mb-0">
                    <p>Already have an account? <span><router-link to="/"
                          class="text-link">Login</router-link></span></p>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-5 col-md-5 no-padding p-0">
          <LoginCarsoule />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import helper from "@/resource/Helper";
import axios from "axios";
import LoginCarsoule from "../NewLogin/Logincarsoule.vue";

export default {
  name: "FrogotEmail",
  components: {
    LoginCarsoule,
  },
  data() {
    return {
      selected_month: null,
      selected_day: null,
      selected_year: null,
      cssn4: null,
      lastname: null,
      verifyLoader: false,
      formErrorFlag: false,
      formErrors: [],
      months: [
        { value: null, text: "Month", disabled: true },
        { value: "01", text: "Jan" },
        { value: "02", text: "Feb" },
        { value: "03", text: "Mar" },
        { value: "04", text: "Apr" },
        { value: "05", text: "May" },
        { value: "06", text: "Jun" },
        { value: "07", text: "Jul" },
        { value: "08", text: "Aug" },
        { value: "09", text: "Sep" },
        { value: "10", text: "Oct" },
        { value: "11", text: "Nov" },
        { value: "12", text: "Dec" },
      ],
      days: [],
      years: [],
    };
  },
  methods: {
    onCssnInput() {
      // Remove any non-digit characters and limit to 4 digits
      if (this.cssn4) {
        this.cssn4 = this.cssn4.toString().replace(/\D/g, '').slice(0, 4);
      }
    },
    onCssnKeypress(event) {
      const key = event.key;
      const controlKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab", "Home", "End"]; 
      if (controlKeys.includes(key)) {
        return;
      }
      if (!/^[0-9]$/.test(key)) {
        event.preventDefault();
      }
    },
    generateDays() {
      const days = [{ value: null, text: "Day", disabled: true }];
      for (let i = 1; i <= 31; i++) {
        const day = i.toString().padStart(2, "0");
        days.push({ value: day, text: day });
      }
      return days;
    },
    getYear() {
      let yearList = [{ value: null, text: "Year", disabled: true }];
      let year = new Date().getFullYear();
      for (let i = year - 100; i <= year; i++) {
        yearList.push({ value: i, text: i });
      }
      this.years = yearList;
    },
    verifyMember(event) {
      if (event) {
        event.preventDefault();
      }
      let [app, inputError] = [this, false];
      app.formErrorFlag = false;
      app.formErrors = {};

      // Validate Last Name
      if (!app.lastname || app.lastname.trim() === "") {
        inputError = true;
        app.formErrors["lastname"] = "Please enter your last name.";
        app.formErrorFlag = true;
      }

      // Validate SSN
      if (!app.cssn4 || app.cssn4.toString().trim() === "" || app.cssn4.length !== 4) {
        inputError = true;
        app.formErrors["cssn"] = "Please enter the last 4 digits of your SSN.";
        app.formErrorFlag = true;
      }

      // Validate Date of Birth
      if (!app.selected_month || !app.selected_day || !app.selected_year) {
        inputError = true;
        app.formErrors["dob"] = "Please select your complete date of birth.";
        app.formErrorFlag = true;
      } else {
        let dob = app.selected_year + "-" + app.selected_month + "-" + app.selected_day;
        if (helper.validateDate(dob) == false) {
          inputError = true;
          app.formErrors["dob"] = "Please enter a valid date of birth.";
          app.formErrorFlag = true;
        }
      }

      // Clear errors after 8 seconds
      if (inputError) {
        setTimeout(() => {
          app.formErrorFlag = false;
          app.formErrors = {};
        }, 8000);
        return;
      }

      // Construct date of birth string for API call
      let dob = app.selected_year + "-" + app.selected_month + "-" + app.selected_day;

      app.verifyLoader = true;

      axios
        .post("/auth/recover-member-details", {
          cssn4: app.cssn4,
          last_name: app.lastname,
          dob: dob,
        })
        .then(function (response) {
          if (response.data.status == "success") {
            helper.infoMessage(
              app,
              response.data.status,
              response.data.message
            );
            app.$router.push({
              name: "RecoverEmail",
              params: { tempEmail: response.data.data.cemail },
            });
          }
        })
        .catch(function (error) {
          if (error.response.data.status == "error") {
            helper.infoMessage(
              app,
              error.response.data.status,
              error.response.data.message
            );
            app.formErrorFlag = true;
            app.formErrors["error"] = error.response.data.message;
            app.loginLoader = false;
            app.verifyLoader = false;
          }
        });
    },
  },
  created() {
    this.days = this.generateDays();
    this.getYear();
  },
};
</script>
<style src="@/assets/css/authen.css"></style>
<style src="@/assets/css/newLogin.css"></style>

<style scoped>
.forget-email-wrapper .date_of_birth {
  display: flex;
  gap: 10px;
}

.forget-email-wrapper .small {
  font-size: 0.75rem;
}
</style>
